require('./jquery.raty.js');
